import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

/**
 * Guard that allows access only when the user has at least one of the required privileges.
 * Configure via route data: data: { requiredPrivileges: ['settings.backup', 'settings.restore'] }
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredPrivileges = (route.data && route.data['requiredPrivileges']) as string[] | undefined;
    if (!requiredPrivileges || requiredPrivileges.length === 0) {
      return true;
    }
    if (this.authService.hasAnyPrivilege(requiredPrivileges)) {
      return true;
    }
    this.notificationService.showWarning('You do not have access to this page.', 4000);
    this.router.navigate(['/dashboard']);
    return false;
  }
}
